module.exports = __webpack_public_path__ + "u5.no2.4f13a675.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/u5.no2.jpg
// module id = Gs/U
// module chunks = 0